import { IApi, Api } from './Api';
import { AxiosInstance } from 'axios';

class SkyPatchApi extends Api implements IApi {
  public constructor(axiosInstance: AxiosInstance) {
    super(axiosInstance);
  }
}

export { SkyPatchApi };
